@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">
		{{ 'masterdata.racking.racksets' | translate }}
	</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	@if (dataSource?.data.length) {
		<table class="table-responsive outer-table" mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
			@for (column of columnsToDisplay; track column) {
				<ng-container matColumnDef="{{ column.name }}">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						{{ column.translateKey | translate }}
					</th>
					@if (column.pipe) {
						<td mat-cell *matCellDef="let element">
							{{ element[column.name] | dynamicPipe: column.pipe }}
						</td>
					} @else {
						<td mat-cell *matCellDef="let element">
							{{ element[column.name] }}
						</td>
					}
				</ng-container>
			}
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef style="text-align: end">
					{{ 'general.actions' | translate }}
				</th>
				<td mat-cell *matCellDef="let row" style="text-align: end">
					<button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
						<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
					</button>
					<mat-menu #menu="matMenu">
						<button mat-menu-item (click)="openCreateEditUpdateRackset(row)">
							<span>{{ 'masterdata.racking.actions.edit' | translate }}</span>
						</button>
						<button mat-menu-item (click)="onDeleteRacksetClick(row)">
							<span>{{ 'masterdata.racking.actions.delete' | translate }}</span>
						</button>
					</mat-menu>
				</td>
			</ng-container>
			<ng-container matColumnDef="expandedDetail">
				<td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
					@if (element.racks?.data.length) {
						<div class="rackset-detail" [@detailExpand]="expandedElements.includes(element) ? 'expanded' : 'collapsed'">
							<table mat-table [dataSource]="element.racks.data" cdkDropList class="racks-list" (cdkDropListDropped)="dropInnerColumn($event, element)">
								<!-- Draggable Inner Columns -->
								@for (innerColumn of innerColumnsToDisplay; track innerColumn) {
									<ng-container matColumnDef="{{ innerColumn.name }}">
										<th mat-header-cell *matHeaderCellDef class="rack-table-header">
											{{ innerColumn.translateKey | translate }}
										</th>
										<td mat-cell *matCellDef="let innerElement" class="rack-table-cell">
											<div>
												@switch (innerColumn.name) {
													@case ('name') {
														<span>
															{{ getDetails($safeNavigationMigration(innerElement['rack']?.self), 'name') }}
														</span>
													}
													@case ('description') {
														<span>
															{{ getDetails($safeNavigationMigration(innerElement['rack']?.self), 'description') }}
														</span>
													}
													@case ('priority') {
														<span>
															{{ getPriority(element.self, $safeNavigationMigration(innerElement['rack']?.self)) }}
														</span>
													}
													@case ('cells') {
														<span>
															{{ getDetails($safeNavigationMigration(innerElement['rack']?.self), 'cells') }}
														</span>
													}
													@case ('rows') {
														<span>
															{{ getDetails(innerElement['rack'].self, 'rows') }}
														</span>
													}
													@case ('columns') {
														<span>
															{{ getDetails($safeNavigationMigration(innerElement['rack']?.self), 'columns') }}
														</span>
													}
													@case ('components') {
														<span>
															{{ getDetails($safeNavigationMigration(innerElement['rack']?.self), 'components') }}
														</span>
													}
												}
											</div>
										</td>
									</ng-container>
								}
								<!-- Extended Actions Column -->
								<ng-container matColumnDef="extendedActions">
									<th mat-header-cell *matHeaderCellDef style="text-align: end">
										{{ 'general.actions' | translate }}
									</th>
									<td mat-cell *matCellDef="let row" style="text-align: end">
										<button mat-icon-button [matMenuTriggerFor]="menu">
											<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
										</button>
										<mat-menu #menu="matMenu">
											<button mat-menu-item (click)="onRemoveRackClick(element, row)">
												<span>
													{{ 'masterdata.racking.remove.removebtn' | translate }}
												</span>
											</button>
										</mat-menu>
									</td>
								</ng-container>
								<!-- Table Rows -->
								<tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
								<tr mat-row cdkDrag class="drag-and-drop-rack-box" *matRowDef="let row; columns: innerDisplayedColumns">
									<!-- Drag Preview -->
									<td [attr.colspan]="innerDisplayedColumns.length" *cdkDragPreview>
										<!-- Displaying properties of innerElement in drag preview -->
										<div class="drag-and-drop-racks">
											<mat-icon svgIcon="acies_racks"></mat-icon>
											<div style="padding-left: 10px">
												<span>
													{{ getDetails($safeNavigationMigration(row.rack?.self), 'name') }}
												</span>
											</div>
										</div>
									</td>
								</tr>
							</table>
						</div>
					}
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			<tr mat-row *matRowDef="let element; columns: displayedColumns" [class.rack-element-row]="element.racks.data.length" [class.rack-expanded-row]="expandedElements.includes(element)" (click)="toggleRow(element)"></tr>
			<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="rackset-detail-row"></tr>
		</table>
	}
</div>
<div [hidden]="$safeNavigationMigration(dataSource?.data.length) <= 0">
	<mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="20" [showFirstLastButtons]="true"></mat-paginator>
</div>
